import { Injectable } from '@angular/core';
import { DataService } from '../data-service/data.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
 
  constructor(private dataService: DataService) {
  }

  login(param) {
    return this.dataService.postService(`/admin/Admin/login`, param);
  }

}
